import React, { useState } from "react";
import clsx from "clsx";
import {
  Button,
  Grid,
  InputLabel,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { AccountCircle } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";

// Components
import AvatarSelection from "./AvatarSelection";

const useStyles = makeStyles((theme) => ({
  dropzone: {
    height: 120,
    width: "100%",
    margin: "0.5rem auto",
    border: "1px dashed lightgrey",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    color: "darkgrey",
  },
  dropzoneError: {
    borderWidth: 2,
    borderColor: theme.palette.error.main,
  },
  image: {
    objectFit: "contain",
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
  field: {
    padding: theme.spacing(0.5, 0),
  },
}));

const ReviewModal = ({ openFormState, commentState, saveReview }) => {
  const classes = useStyles();

  // FORM
  const [openForm, setOpenForm] = openFormState;
  const [comment, setComment] = commentState;
  const [err, setErr] = useState(false);

  const onClose = () => setOpenForm(false);

  const onConfirm = () => {
    let filled = true;

    Object.values(comment.data).map((val) => {
      if (val === "") filled = false;
    });

    if (filled) {
      saveReview();
      onClose();
    } else {
      setErr(true);
    }
  };

  const handleChange = (e) => {
    const id = e.target.id;
    let value = e.target.value;

    setComment({ ...comment, data: { ...comment.data, [id]: value } });
  };

  // IMAGE
  const [browserOpen, setBrowserOpen] = useState(false);

  const browserSelect = (image_url) => {
    setComment({ ...comment, data: { ...comment.data, avatar: image_url } });
  };

  return (
    <Dialog
      disableBackdropClick
      fullWidth
      maxWidth="sm"
      open={openForm}
      onClose={onClose}
    >
      {browserOpen && (
        <AvatarSelection
          browserOpenState={[browserOpen, setBrowserOpen]}
          browserSelect={browserSelect}
          image_url={comment.data.avatar}
        />
      )}
      <DialogTitle>
        {comment.action}
        Review
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={6} container spacing={2} alignItems="center">
            <Grid item xs={7}>
              <InputLabel shrink required>
                Avatar
              </InputLabel>
              <Grid
                item
                container
                className={clsx({
                  [classes.dropzone]: true,
                  [classes.dropzoneError]: err && !comment.data.avatar,
                })}
              >
                {comment.data.avatar ? (
                  <img
                    height="100%"
                    width="100%"
                    src={comment.data.avatar}
                    className={classes.image}
                    alt=""
                  />
                ) : (
                  <AccountCircle fontSize="large" />
                )}
              </Grid>
            </Grid>
            <Grid item xs>
              <Button
                variant="outlined"
                color="primary"
                className={classes.button}
                onClick={() => setBrowserOpen(true)}
              >
                Choose
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid item xs className={classes.field}>
              <TextField
                required
                fullWidth
                size="small"
                margin="dense"
                variant="outlined"
                label="Name"
                id="name"
                name="name"
                value={comment.data.name}
                placeholder="Jane L."
                onChange={handleChange}
                error={err && !comment.data.name}
              />
            </Grid>
            <Grid item xs className={classes.field}>
              <TextField
                required
                fullWidth
                size="small"
                margin="dense"
                variant="outlined"
                label="Location"
                id="location"
                name="location"
                value={comment.data.location}
                placeholder="Toms River, NJ"
                onChange={handleChange}
                error={err && !comment.data.location}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} className={classes.field}>
            <TextField
              required
              fullWidth
              multiline
              rows="3"
              maxRows="10"
              size="small"
              margin="dense"
              variant="outlined"
              label="Comment"
              id="comment"
              name="comment"
              value={comment.data.comment}
              onChange={handleChange}
              error={err && !comment.data.comment}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={onConfirm}
        >
          {comment.action === "Edit" ? "Save" : "Create"}
        </Button>
        <Button
          variant="contained"
          color="secondary"
          className={classes.button}
          onClick={onClose}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReviewModal;
